export default "__VITE_ASSET__Dogpb6rl__"